import { useMemo, useState } from 'react'

import { SubscribedOnDataDto } from '@api'
import { format } from 'date-fns/format'

import { toUsdFormat } from '@/modules/chatting/ui/chat-window/fan-info/utils'

import { ExpandableDetails } from './ExpandableDetails'

interface Props {
  subscription: SubscribedOnDataDto
}

export const EarningsDetails = ({ subscription }: Props) => {
  const [isExpanded, setIsExpanded] = useState(false)

  const details = useMemo(() => {
    return [
      {
        label: 'Last activity',
        value: subscription.expiredAt
          ? format(new Date(subscription.expiredAt), 'MMM dd, yyyy')
          : '',
        hideable: false,
      },
      {
        label: 'Subscriptions',
        value: toUsdFormat(subscription.subscribesSumm || 0),
        hideable: true,
      },
      {
        label: 'Posts',
        value: toUsdFormat(subscription.postsSumm || 0),
        hideable: true,
      },
      {
        label: 'Messages',
        value: toUsdFormat(subscription.messagesSumm || 0),
        hideable: true,
      },
      {
        label: 'Streams',
        value: toUsdFormat(subscription.streamsSumm || 0),
        hideable: true,
      },
      {
        label: 'Tips',
        value: toUsdFormat(subscription.tipsSumm || 0),
        hideable: true,
      },
      {
        label: 'Total',
        value: toUsdFormat(subscription.totalSumm || 0),
        hideable: false,
      },
    ]
  }, [subscription])

  return (
    <ExpandableDetails
      details={details}
      isExpanded={isExpanded}
      setIsExpanded={setIsExpanded}
    />
  )
}
